<template>
  <div>
    <div class="pt-2 pb-2 header-text">
      {{ translationsFormatter('prizes_header') }}
    </div>

    <div class="p-2 text-center promo-text">
      {{ translationsFormatter('prizes_promo_info') }}
    </div>

    <!-- Prizes table -->
    <div class="mt-2">
      <table class="table table-bordered">
        <thead>
        <tr class="table-header secondary-bg-colour primary-text">
          <th scope="col">#</th>
          <th scope="col">TYPE</th>
          <th scope="col">DRAWS</th>
          <th scope="col">UNIT / DRAW</th>
          <th scope="col">COST / UNIT (LC)</th>
        </tr>
        </thead>
        <tbody class="table-body primary-bg-colour">
        <tr>
          <th scope="row">1</th>
          <td>Data/Airtime Coupon</td>
          <td>Daily</td>
          <td>200</td>
          <td>R5.00</td>
        </tr>
        <tr>
          <th scope="row">2</th>
          <td>Fantasy Predictor Coupon</td>
          <td>Daily</td>
          <td>100</td>
          <td>R10.00</td>
        </tr>
        </tbody>
      </table>
      <div class="smaller-text mt-1">
        <b>Total prize value:</b> R720,000.00 (seven hundred and twenty thousand Rand)
      </div>
      <div class="smaller-text mt-1">
        Prizes/rewards depend on coins earned and engagement. Telkom &amp; Penrose Systems may adjust prize pools, points and leaderboard mechanics.
      </div>
    </div>

    <!-- Coins earning structure -->
    <div class="pt-3 pb-1 header-text">
      {{ translationsFormatter('coins_header') || 'Coins Earning Structure' }}
    </div>
    <div class="mt-1">
      <table class="table table-bordered">
        <thead>
        <tr class="table-header secondary-bg-colour primary-text">
          <th scope="col">ACTIVITY</th>
          <th scope="col">COINS EARNED</th>
        </tr>
        </thead>
        <tbody class="table-body primary-bg-colour">
        <tr>
          <td>Subscribing to the Premium Service</td>
          <td>50</td>
        </tr>
        <tr>
          <td>First play on freemium service</td>
          <td>10</td>
        </tr>
        <tr>
          <td>Answering each question correctly</td>
          <td>10</td>
        </tr>
        </tbody>
      </table>
      <div class="smaller-text">
        Once the requirements of section 4 and 5.3 are met, entry into the Competition is automatic. Getting both USSD
        questions right doubles the session’s coin earnings; incorrect answers halve them.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TelkomZaPrizes",
  computed: {
    ...mapState(["brandConfig"]),
  },
};
</script>

<style scoped>
.smaller-text {
  font-size: x-small !important;
}

.header-text {
  font-size: 1.2rem;
  font-weight: bold;
}

.promo-text {
  font-weight: 700;
  font-size: 15px;
}

.table-header {
  font-size: 13px;
}

table {
  border: 1px solid black;
}

.table-body {
  font-size: 11px;
}
</style>
`
